import script from "./Region.vue?vue&type=script&setup=true&lang=js"
export * from "./Region.vue?vue&type=script&setup=true&lang=js"

import "./Region.vue?vue&type=style&index=0&id=dadc3612&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dadc3612"]])

export default __exports__